/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const ArrowLeftIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width={size} height={size} {...props}><path fillRule="evenodd" d="M11.207 3.793a1 1 0 0 1 0 1.414L5.414 11H21a1 1 0 1 1 0 2H5.414l5.793 5.793a1 1 0 0 1-1.414 1.414l-7.5-7.5a1 1 0 0 1 0-1.414l7.5-7.5a1 1 0 0 1 1.414 0" clipRule="evenodd" /></svg>;
};
export default ArrowLeftIcon;